<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Order.address.resetAddress") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>

      <!-- 表格 -->
      <v-data-table
        :headers="headers"
        :items="shopAddressItems"
        :loading="shopsLoading"
        :search="filter"
        multi-sort
        class="elevation-0 px-6"
        fixed-header
        height="340px"
        :footer-props="footerProps"
      >
        <template v-slot:header.action="{ header }">
          {{ header.text }}
          <v-icon x-small>fa-sliders-h</v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-btn
              color="primary"
              dense
              @click="
                $emit('confirm', item);
                dialog = false;
              "
            >
              {{ $t("Shop.Fields.choose") }}
            </v-btn>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.abandon") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import consts from "@/consts";
import ShopAddress from "@/api/shop_address";

export default {
  name: "DialogShopAddress",

  components: {},

  props: {
    value: Boolean,
    shop_id: Number,
    order_extra: Object,
  },
  mounted() {},

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Area.city_1"),
          align: "start",
          sortable: true,
          value: "province_name",
        },
        {
          text: i18n.t("Area.city_2"),
          align: "start",
          sortable: true,
          value: "city_name",
        },
        {
          text: i18n.t("Area.city_3"),
          align: "start",
          sortable: true,
          value: "area_name",
        },
        {
          text: i18n.t("Shop.Fields.shop_receiving_address", [consts.shopName()]),
          align: "start",
          sortable: true,
          value: "address",
        },
        {
          text: i18n.t("Shop.Fields.shop_address_name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: i18n.t("Shop.Fields.shop_user_tel"),
          align: "start",
          sortable: true,
          value: "phone",
        },
        {
          text: i18n.t("Shop.Fields.action"),
          align: "start",
          sortable: false,
          value: "action",
        },
      ]
    },
    shopAddressItems() {
      return this.shopAddress
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    dialog: false,
    filter: "",
    shopAddress: [],
    shopsLoading: false,
    paging: {},
    itemsPerPageOptions: 5,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          // 每次打开对话框重置查询
          this.getShopAddressFromAPI();
        }else {
          this.shopAddress = []
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },

  methods: {
    // resizeHeader() {
    //   this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    // },

    getShopAddressFromAPI() {
      this.shopsLoading = true;

      ShopAddress.fetchByShop({shop_id:this.shop_id})
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.shopAddress = response.data.shop_address;
              if (JSON.stringify(this.order_extra) == '{}') {
                this.shopAddress.splice(0,1)
              }else {
                this.shopAddress.splice( this.shopAddress.findIndex(
                  (address) => (
                    address.name == this.order_extra.express.receiver_name &&
                    address.phone == this.order_extra.express.receiver_phone &&
                    address.province_name == this.order_extra.express.receiver_province &&
                    address.city_name == this.order_extra.express.receiver_city &&
                    address.area_name == this.order_extra.express.receiver_area &&
                    address.address == this.order_extra.express.receiver_address
                  )
                ),1)

              }
            }
            this.shopsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.shopsLoading = false;
          }.bind(this)
        );
    },
  },
};
</script>
